import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';

/**
 * Generated class for the VideoDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-video-detail',
    templateUrl: 'video-detail.html',
})
export class VideoDetailPage {
    item: any = {};

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {
        this.item = this.navParams.get('item');
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad VideoShopPage');
    }
    parseCourseWay(course_way) {
        course_way = course_way.replace(/\[heading\]/g, '<h4>');
        course_way = course_way.replace(/\[end:heading\]/g, '</h4>');

        course_way = course_way.replace(/\[row\]/g, `<p> <img src="assets/imgs/icons/play-button.png" />`);
        course_way = course_way.replace(/\[end:row\]/g, '</p>');


        // course_way = this.nl2br(course_way);

        return course_way;
    }

    nl2br(value: string, args: string[] = []): any {
        if (!value) return value;
        let breakTag = '<br>';
        return (value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
}



// WEBPACK FOOTER //
// ./src/pages/video-detail/video-detail.ts